export var DrawerType;
(function (DrawerType) {
    DrawerType[DrawerType["NONE"] = 0] = "NONE";
    DrawerType[DrawerType["ENTITY"] = 1] = "ENTITY";
    DrawerType[DrawerType["EXPORT_TEMPLATE"] = 2] = "EXPORT_TEMPLATE";
    DrawerType[DrawerType["COMMENTS"] = 3] = "COMMENTS";
})(DrawerType || (DrawerType = {}));
//# sourceMappingURL=drawer-type.enum.js.map